import {take} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, ReplaySubject} from 'rxjs';
import {DataEntity, OctopusConnectService} from 'octopus-connect';
import {defaultLoginRoute, defaultRoute} from '../settings';

@Injectable()
export class IsDefaultOrDefaultLoginRoute  {

    userInformation: DataEntity;

    constructor(
        private connector: OctopusConnectService,
        private router: Router,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): ReplaySubject<boolean> {
        const subject: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

        const obs: Observable<DataEntity> = this.connector.authenticated('http');

        obs.pipe(take(1)).subscribe((userData: DataEntity) => {
            subject.next(false);
            this.router.navigate([defaultLoginRoute]);
        }, () => {
            subject.next(true);
            this.router.navigate([defaultRoute]);
        });

        return subject;
    }
}
